module.exports = __webpack_public_path__ + "ENG_SPT5-Birthday_225002526-3ee4bc39b32dff3ea8d0f6bb0bb5ebe9.png";